import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Departments} from '../departments';
import {UsersShowComponent} from '../../users/users-show/users-show.component';
import {BranchesShowComponent} from '../../branches/branches-show/branches-show.component';
import {DepartmentsService} from '../departments.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {BranchService} from "../../branches/branch.service";
import {UserService} from '../../../../services';
import {TreeNode} from 'primeng/api';
import {TreeModule} from "primeng/tree";


@NgModule({
    imports: [CommonModule, FormsModule, TreeModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        DepartmentsShowComponent
    ],
    entryComponents: [
        DepartmentsShowComponent
    ],
    exports: [],
    providers: [SharedService, DepartmentsService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-departments-show',
    templateUrl: './departments-show.component.html',
    styleUrls: ['./departments-show.component.scss'],
    providers: [DepartmentsService, ConfirmationService, MessageService]
})

export class DepartmentsShowComponent implements OnInit, AfterViewInit {
    id: string;
    departments =  new Departments();
    @Input() refShow;
    currency: any[] = [];
    alldepartments: any[] = [];
    branches: any[] = [];
    allusers: any[] = [];
    hiddenFields: any[] = [];

    applog: AppLogComponent;
    parent_name: any;
    @Input() scrId;
    modalRef: NgbModalRef;
    parent:any;
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() modelName;
    tree: TreeNode[];
    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private departmentsService: DepartmentsService,
                private branchService: BranchService,
                private userService: UserService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService){
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        this.msgs =[];

        if(userdata && userdata.lang){
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('departments');
        this.sharedservice.setItemShow(DepartmentsShowComponent);
    }

    showParent(){
        if(this.parent){
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(DepartmentsShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent.id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showManager(){
        if(this.departments.manager_id){
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(UsersShowComponent, options);
            this.modalRef.componentInstance.scrId = this.departments.manager_id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    showBranch(){
        if(this.departments.branch_id){
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(BranchesShowComponent, options);
            this.modalRef.componentInstance.scrId = this.departments.branch_id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    recordData(){
        const options: NgbModalOptions = {
            beforeDismiss: () => {
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.departments;
        modalRef.componentInstance.rowId = '';
    }

    ngAfterViewInit() {
        if(!this.scrId && !this.oldData && !this.scrId) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');

            if(this._editButton){
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/departments/edit', this.id]);
                });
            }
            
            if(this._deleteButton){
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteDepartment(this.departments);
                });
            }

            if(this._newButton){
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/departments']);
                });
            }
            if(this._searchButton){
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/departments/search']);
                });
            }
        }
    }

    fieldsControl(screen: string = '') {
        if (screen === '') {
            return;
        }
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (!userdata.fields) {
            this.hiddenFields = [];
        } else {
            this.hiddenFields = (userdata.fields.screens[screen]) ? userdata.fields.screens[screen] : [];
        }
    }

    nodeSelect(_id: string) {
        this.msgs = [];
        this.id = _id;
        this.departmentsService.getAllDepartments().subscribe(
            data => {
                this.alldepartments = data.departmentslist;
            });
        this.departmentsService.getById(_id).subscribe(
            departments => {
                this.departments = departments;
                this.form.patchValue({
                    id: departments.id,
                    name: departments.name,
                    status: departments.status,
                    dep_id: departments.dep_id,
                    parent_id: departments.parent_id,
                    branch_id: departments.branch_id,
                    manager_id: departments.manager_id,
                  });
            }, error => {
                console.log(error);
            }
        );
    }

    
    addnew(_id: string) {
        this.router.navigate(['/departments', _id]);
    }

    ngOnInit(){
        this.departmentsService.getTree('0').then(tree => this.tree = tree);
        this.msgs =[];

        this.departmentsService.getAllDepartments().subscribe(
            data => {
                this.alldepartments = data.departmentslist;
            });


        this.branchService.getAllBranches().subscribe(
            data => {
                this.branches = data.brancheslist;
            });

        this.userService.getAllUsers().subscribe(
            data => {
              this.allusers = data.userslist;
            });
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            dep_id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            manager_id: new FormControl({value: '', disabled: true}),
            parent_id: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true}),
            branch_id: new FormControl({value: '', disabled: true}),
        });

        this.fieldsControl('setting.departments');

        if(this.id){
            this.msgs =[];
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            this.newDatap = true;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if(msg){
                localStorage.removeItem('showMessages');
                this.msgs = msg;
            }
            this.departmentsService.getById(this.id).subscribe(
                department => {
                    this.id = department.id;
                    this.departments = department;
                    this.parent = department.parent;
                    this.form.patchValue({
                        name: department.name,
                        dep_id: department.dep_id,
                        status: department.status,
                        manager_id: department.manager_id,
                        parent_id: department.parent_id,
                        branch_id: department.branch_id,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if(this.scrId){
            this.oldData = false;
            this.newData = false;
            this.delId = false;

            this.departmentsService.getById(this.scrId).subscribe(
                department => {
                    this.id = department.id;
                    this.departments = department;
                    this.parent = department.parent;
                    this.form.patchValue({
                        name: department.name,
                        dep_id: department.dep_id,
                        status: department.status,
                        manager_id: department.manager_id,
                        parent_id: department.parent_id,
                        branch_id: department.branch_id,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if(this.delId){
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.departmentsService.getTrashedById(this.delId).subscribe(
                department => {
                    this.departments = department;
                    this.form.patchValue({
                        id: department.id,
                        name: department.name,
                        dep_id: department.dep_id,
                        status: department.status,
                        manager_id: department.manager_id,
                        parent_id: department.parent_id,
                        branch_id: department.branch_id,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if(this.oldData && this.newData){
            this.departments = this.newData;
            this.form.patchValue({
                name: this.newData.name,
                dep_id: this.newData.dep_id,
                status: this.newData.status,
                manager_id: this.newData.manager_id,
                parent_id: this.newData.parent_id,
                branch_id: this.newData.branch_id,
            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if(userdata){
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button){
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('setting.departments.' + role) >= 0){
            return true;
        }
        return false;
    }

    deleteDepartment(departments: Departments){
        this.msgs = [];
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if(departments){
                    this.departmentsService.delete(departments.id).subscribe(
                        res => {
                            if (res.result == false) {
                                this.msgs.push({
                                    severity: 'error',
                                    summary: '',
                                    detail: this.translate.instant(res.message)
                                });
                            } else {
                                this.msgs.push({
                                    severity: 'success',
                                    summary: '',
                                    detail: this.translate.instant('Delete completed')

                                });
                                setTimeout(() => {
                                    this.router.navigate(['/departments']);
                                }, 1000);
                            }
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                        }
                    );
                }
            }
        });
    }

    recoverEdit(departments: Departments){
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if(departments){
                    this.departmentsService.update(departments).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/departments/show', departments.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed(){
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if(this.delId){
                    this.departmentsService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted department recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/departments/list']);
                        }
                    );
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/views/setting/departments/departments-show/departments-show.component.ts